<template>
    <div>
        <hr class="mb-3">
        <RegisterBuildingComponent v-if="buildingInfo.id" :buildingInformation="buildingInfo" :apiMethod="apiMethod">
            <div slot="SuccessMessage">
                <transition name="fade">
                    <div class="alert alert-success">The building has been updated.</div>
                </transition>
            </div>
        </RegisterBuildingComponent>
    </div>
</template>
<script>
  import RegisterBuildingComponent from '../../../../components/building-registration/BuildingRegistrationComponent.vue'
  import Vue from 'vue'

    export default {
      components: {
        RegisterBuildingComponent,
      },
      data () {
        return {
          id: '',
          buildingInfo: {},
          apiMethod: {
            method: 'PATCH',
            path: 'api/v1/sites/' + this.id,
            path_template: '/api/buildings/{id}',
            section: 'fixture',
          }
        }
      },
      created () {
        this.id = this.$route.params.buildingId;
        this.apiMethod.path = 'api/v1/sites/' + this.id
        Vue.set(this, 'buildingInfo', {
          contract_no: undefined,
          inner: undefined,
          email_template: undefined,

          id: undefined,
          name: undefined,
          strataNo: undefined,
          latitude: undefined,
          longitude: undefined,
          address: undefined,
          suburb: undefined,
          postCode: undefined,
          state: undefined,
          key: undefined,
          parking: undefined,
          toilet: undefined,
          note: undefined,
        });

        this.$store.dispatch('apiResult', {
          method: 'GET',
          path: 'api/buildings/' + this.id,
          path_template: '/api/buildings/{id}',
          section: 'emiot',
        }).then(response => {
          switch (response.status) {
            case 200:
              this.buildingInfo['contract_no'] = response.data.data.contract_no;
              this.buildingInfo['inner'] = response.data.data.inner;
              this.buildingInfo['email_template'] = response.data.data.email_template;
              break
          }
        });

        this.$store.dispatch('apiResult', {
          method: 'GET',
          path: 'api/v1/sites/' + this.id,
          path_template: '/api/buildings/{id}',
          section: 'fixture',
        }).then(response => {
            switch (response.status) {
              case 200:
                this.buildingInfo['name'] = response.data.name;
                this.buildingInfo['strataNo'] = response.data.strataNo;
                this.buildingInfo['latitude'] = response.data.latitude;
                this.buildingInfo['longitude'] = response.data.longitude;
                this.buildingInfo['address'] = response.data.address;
                this.buildingInfo['suburb'] = response.data.suburb;
                this.buildingInfo['postCode'] = response.data.postCode;
                this.buildingInfo['state'] = response.data.state;
                this.buildingInfo['key'] = response.data.key;
                this.buildingInfo['parking'] = response.data.parking;
                this.buildingInfo['toilet'] = response.data.toilet;
                this.buildingInfo['note'] = response.data.note;
                this.buildingInfo['id'] = response.data.id;
                break
            }
          });
      },
    }
</script>